import React, { useEffect, useState } from 'react';

import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import stylesMaterial from './stylesMaterial';
import { Container, Header, ExtraOptions } from './styles';
import melhorEnvioService, { IAgency } from '../../../../../services/melhorEnvio';
import { useToast } from '../../../../../hooks/toast';
import { IOrderItem } from '../../../../../interfaces/IOrderItem';
import { IPaymentMethod } from '../../../../../interfaces/IPaymentMethod';
import { IDeliveryAddress } from '../../../../../interfaces/IDeliveryAddress';
import { IOrder } from '../../../../../interfaces/IOrder';
import geographicApi, { ICity } from '../../../../../services/geographicApi';
import empresaApi, { IEmpresa } from '../../../../../services/empresaApi';

interface InsertCartOptionsModalProps {
  open: boolean;
  handleClose: () => void;
  loadPedidoData: () => {};
  order:
    | (Partial<IOrder> & {
        deliveryAddress?: Partial<IDeliveryAddress>;
        orderPayment: Partial<IPaymentMethod> & { companyPaymentMethod?: any }; // alterar
        items: Partial<IOrderItem>[];
      })
    | null;
  companyId: number;
}

export function InsertCartOptionsModal({
  open,
  handleClose,
  loadPedidoData,
  order,
  companyId,
}: InsertCartOptionsModalProps) {
  const classes = stylesMaterial();

  const { addToast } = useToast();

  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [commercial, setCommercial] = useState('');
  const [company, setCompany] = useState<IEmpresa | null>(null);
  const [cityOptions, setCityOptions] = useState<ICity[]>([]);
  const [selectedCity, setSelectedCity] = useState<ICity | null>(null);
  const [agencyOptions, setAgencyOptions] = useState<IAgency[]>([]);
  const [selectedAgency, setSelectedAgency] = useState<IAgency | null>(null);
  const [cnaeCode, setCnaeCode] = useState('');
  const [isInsertCartLoading, setIsInsertCartLoading] = useState(false);

  useEffect(() => {
    empresaApi
      .getCompany(companyId)
      .then((res) => {
        setCompany(res);
        geographicApi
          .getCidades(res.endereco.estado)
          .then((citiesRes) => {
            setCityOptions(citiesRes);
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));
  }, [companyId]);

  useEffect(() => {
    if (company && selectedCity) {
      melhorEnvioService
        .findAgencies(company.endereco.estado, selectedCity.nome, company.id)
        .then((res) => {
          if (res) {
            setAgencyOptions(res);
          } else {
            setAgencyOptions([]);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [company, selectedCity]);

  function handleInsertOrderInCart() {
    if (order && order.id) {
      if (commercial === '') {
        addToast({
          title: 'Selecione uma opção',
          type: 'error',
        });
      } else if (commercial === 'commercial' && !invoiceNumber) {
        addToast({
          title: 'Digite o número da nota fiscal',
          type: 'error',
        });
      } else if (
        order?.logisticDelivery?.nome_transportadora.toLocaleLowerCase() ===
          'jadlog' &&
        !selectedAgency
      ) {
        addToast({
          title: 'Selecione uma agência',
          type: 'error',
        });
      } else if (
        order?.logisticDelivery?.nome_transportadora.toLocaleLowerCase() ===
          'latam cargo' &&
        !cnaeCode
      ) {
        addToast({
          title: 'Digite o código CNAE',
          type: 'error',
        });
      } else {
        setIsInsertCartLoading(true);
        melhorEnvioService
          .insertCart(
            selectedAgency ? selectedAgency.id : null,
            cnaeCode,
            commercial === 'commercial' ? invoiceNumber : '',
            order.id,
            companyId,
          )
          .then((res) => {
            loadPedidoData();
            addToast({
              title: 'Adicionado ao carrinho com sucesso',
              type: 'success',
            });
            handleClose();
          })
          .catch((error) => {
            setIsInsertCartLoading(false);
            if (error.response && error.response.data) {
              addToast({
                title: error.response.data.message,
                type: 'error',
              });
            } else {
              addToast({
                title: 'Ocorreu um erro na adição ao carrinho',
                type: 'error',
              });
            }
          });
      }
    }
  }

  const handleChangeCommercial = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCommercial((event.target as HTMLInputElement).value);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="insert-in-cart-options-modal"
      aria-describedby="insert-in-cart-options-balance"
      className={classes.modal}
    >
      <Container>
        <Header>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.buttonClose}
          >
            <CloseIcon className={classes.iconClose} />
          </IconButton>
        </Header>

        <FormControl className={classes.formControl}>
          <FormLabel component="legend">Envio comercial</FormLabel>
          <RadioGroup
            aria-label="commercial"
            name="commercial"
            value={commercial}
            onChange={handleChangeCommercial}
          >
            <FormControlLabel
              value="non-commercial"
              control={<Radio />}
              label="Envio não comercial: Não há geração de nota fiscal"
            />
            <FormControlLabel
              value="commercial"
              control={<Radio />}
              label="Envio comercial: Há geração de nota fiscal"
            />
          </RadioGroup>

          {commercial === 'commercial' && (
            <TextField
              id="value"
              label="Chave da Nota Fiscal"
              variant="outlined"
              value={invoiceNumber}
              onChange={(event) => setInvoiceNumber(event.target.value)}
              style={{ width: 300 }}
            />
          )}

          {order?.logisticDelivery?.nome_transportadora.toLocaleLowerCase() ===
            'jadlog' && (
            <ExtraOptions>
              <Typography>
                Para envios com JadLog selecione a agência:
              </Typography>
              <Autocomplete
                id="combo-box-city"
                options={cityOptions}
                getOptionLabel={(option) => option.nome}
                value={selectedCity}
                onChange={(event: any, newValue: ICity | null) => {
                  if (newValue !== null) {
                    setSelectedCity(newValue);
                  }
                }}
                getOptionSelected={(option, value) => _.isEqual(option, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="city"
                    type="city"
                    label="Cidade"
                    variant="outlined"
                  />
                )}
              />
              <Autocomplete
                id="combo-box-agencies"
                options={agencyOptions}
                getOptionLabel={(option) => option.name}
                value={selectedAgency}
                onChange={(event: any, newValue: IAgency | null) => {
                  if (newValue !== null) {
                    setSelectedAgency(newValue);
                  }
                }}
                getOptionSelected={(option, value) => _.isEqual(option, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="agency"
                    type="agency"
                    label="Agência"
                    variant="outlined"
                  />
                )}
                noOptionsText={
                  selectedCity
                    ? 'Sem opções'
                    : 'Sem opções (selecione uma cidade)'
                }
              />
            </ExtraOptions>
          )}

          {order?.logisticDelivery?.nome_transportadora.toLocaleLowerCase() ===
            'latam cargo' && (
            <ExtraOptions>
              <Typography>
                Para envios com LATAM Cargo digite o código CNAE:
              </Typography>

              <TextField
                id="cnae"
                label="Código CNAE"
                variant="outlined"
                value={cnaeCode}
                onChange={(event) => setCnaeCode(event.target.value)}
                style={{ width: 300 }}
              />
            </ExtraOptions>
          )}

          <Button
            disabled={isInsertCartLoading}
            onClick={handleInsertOrderInCart}
            className={classes.button}
          >
            {isInsertCartLoading ? <CircularProgress /> : 'Concluir'}
          </Button>
        </FormControl>
      </Container>
    </Modal>
  );
}
